<template lang="pug">
#NavBar
  .navbar-bg(:style="navbarBg")
  b-container(fluid="lg")
    .navbar-header
      div(style="cursor: pointer;" @click="$router.push('/')")
        picture
          // :TODO Se comenta logo avion, en logo normal estará en responsive
          //source(srcset="../../assets/logos/avion_naranjo.png" media="(max-width: 768px)")
          img.logo(src="../../assets/logos/blanco_avion.png")
      .user-info
        .user-info-item(v-if="user.store && !isMobile")
          div.user-icon.material-icons-outlined.mr-2 store
          div {{user.store.name}}
        .user-info-item
          span.user-icon.material-icons-outlined.mr-2(v-if="!isMobile") account_circle
          span(style="font-weight: 600;" v-if="!isMobile") {{fullName}}

          //- Dropdown Icono Escaner para vista conductor
          b-dropdown(v-if="user.role === 'driver'" id="dropdown-1" @show="fetchUser()" right no-caret variant="link" toggle-class="text-decoration-none text-white")
            template(#button-content)
              span.material-icons-outlined qr_code_scanner

            b-dropdown-item(
              v-if="user.role === 'driver' && user.canReceivePackages"
              :to="'/escaner-en-tienda'"
              exact
            ) Escanear en Tienda

            b-dropdown-item(
              v-if="user.role === 'driver' && user.canReceivedInWarehouse"
              :to="'/recepcion-en-bodega'"
              exact
            ) Recepcionar en bodega

            b-dropdown-item(
              v-if="user.role === 'driver' && user.canReceivePackages"
              :to="'/escaner-ruta-conductor'"
              exact
            ) Escanear ruta conductor

          b-dropdown(@show="fetchUser()" id="dropdown-1" right no-caret variant="link" toggle-class="text-decoration-none text-white")
            template(#button-content)
              span.material-icons-outlined menu

            b-dropdown.pl-2(v-if="user.role === 'admin' || user.role === 'viewer' || user.role === 'driver' && (user.canReceivePackages || user.canReceivedInWarehouse)"
              id="dropdown-2"
              dropright text="Escanear"
              variant="link"
              toggle-class="text-decoration-none"
            )
              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'driver' && user.canReceivePackages"
                :to="'/escaner-en-tienda'"
                exact
              ) Escanear en Tienda

              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'viewer' || user.role === 'driver' && user.canReceivedInWarehouse"
                :to="'/recepcion-en-bodega'"
                exact
              ) Recepcionar en bodega

              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'driver' && user.canReceivePackages"
                :to="'/escaner-ruta-conductor'"
                exact
              ) Escanear ruta conductor

              b-dropdown-item(
                v-if="user.role === 'admin' || user.role === 'viewer'"
                :to="'/cambios-devoluciones'"
                exact
              ) Cambios y devoluciones

            b-dropdown-item(@click="logout") Cerrar Sesión

    b-navbar.bar.sombra(variant="light" toggleable="md" v-if="user.role.includes('admin') || user.role.includes('store') || user.role==='viewer'")
      b-navbar-toggle(target="nav-collapse")
      b-collapse#nav-collapse.bg-white(is-nav)
        b-navbar-nav
          .link(v-if="['admin', 'store', 'viewer'].includes(user.role)")
            .material-icons-outlined local_shipping
            b-nav-item(:to="'/envios-tienda'") Envíos
          .link(v-if="['admin', 'store', 'viewer'].includes(user.role)")
            .material-icons-outlined event_note
            b-nav-item(:to="'/retiros-tienda'") Retiros
          .link(v-if="user.role==='admin'")
            .material-icons-outlined admin_panel_settings
            b-nav-item(:to="'/usuarios'") Adm.Usuarios
          .link(v-if="user.role==='admin'")
            .material-icons-outlined store
            b-nav-item(:to="'/tiendas'") Tiendas
          .link(v-if="user.role==='admin'")
            .material-icons-outlined near_me
            b-nav-item(:to="'/regiones'") Adm.Regiones
          .link(v-if="user.role==='store'")
            .material-icons-outlined manage_accounts
            b-nav-item(:to="'/mi-tienda'") Mi Tienda
          .link(v-if="user.role==='admin'")
            .material-icons-outlined email
            b-nav-item(:to="'/mensajes'") Mensajes
          .link(v-if="user.role==='admin'")
            .material-icons-outlined groups
            b-nav-item(:to="'/grupos'") Grupos
          .link(
            v-if="checkPermissions([permissions.STORE_SHOPIFY_INTEGRATION, permissions.STORE_API_ACCESS])"
          )
            .material-icons-outlined integration_instructions
            b-nav-item(:to="'/integraciones'") Integraciones
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { permissions } from '../../utils/authUtils'

export default {
  data () {
    return {
      permissions,
      fullName: {},
      isMobile: false
    }
  },
  mounted () {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.fetchUser()
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  created () {
    this.getUser()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    ...mapActions(['logout', 'fetchUser']),
    getUser () {
      const user = JSON.parse(localStorage.getItem('user')).user
      this.fullName = `${user.name} ${user.lastName}`
    },
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
    },
    checkRole (roles) {
      return roles.includes(this.user.role)
    }
  },
  computed: {
    ...mapGetters(['user', 'checkPermissions']),
    navbarBg () {
      if (this.user.role !== 'driver') {
        return 'height: calc(100% - 30px);'
      } else {
        return 'height: 100%;'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#NavBar {
  position: relative;
  .navbar-bg {
    position: absolute;
    width: 100%;
    background-color: var(--secondary);
  }
  .navbar-header {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 100px;
    padding: 5px 0;
    column-gap: 10px;
  }
  .user-info {
    position: relative;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    column-gap: 10px;
    flex-grow: 4;
    .user-info-item {
      display: flex;
      font-weight: 600;
      align-items: center;
      justify-content: flex-end;
      .dropdown {
        .btn {
          padding: 0 !important;
        }
      }
    }
    .user-icon {
      display: block !important;
      color: #FCA721;
      background-color: white;
      border-radius: 50%;
      border: 2px white solid;
    }
    color: white !important;
  }
}
#NavBar .navbar-header {
  @media (max-width: 768px) {
    min-height: 70px;
  }
}
.bar {
  height: 70px;
  border-radius: 10px;
  font-family:'Source Sans Pro Semi Bold', sans-serif;
  font-weight: 700;
  font-size: 15px;
  z-index: 2;
}
.logo {
  position: relative;
  max-height: 60px;
  margin-bottom: 5px;
  @media (max-width: 768px) {
    max-height: 35px;
  }
}

.link{
  color: var(--light-primary);
  align-items: center;
  display: flex;
  margin-right: 20px;
}
.scanner-btn {
  background-color: transparent;
  margin: 0.5rem;
  margin-left: 1rem;
  border: none;
  cursor: pointer;

}
</style>
